import React from 'react';
import { Grid } from '@material-ui/core';
import MandatoryTagGroup from './MandatoryTagGroup';
import OptionalTags from './OptionalTags';

function GridTagFields(props) {
    const { control, errors, mandatoryTagGroups, optionalTags } = props;

    if (mandatoryTagGroups.length > 0 || optionalTags.length > 0) {
        return (
            <>
                {
                    mandatoryTagGroups.length > 0 &&
                    mandatoryTagGroups.map(tagGroup => {
                        return (
                            <Grid key={tagGroup.field_key} item xs={12}>
                                <MandatoryTagGroup tagGroup={tagGroup} control={control} errors={errors}/>
                            </Grid>
                        )}
                    )
                }
                {
                    optionalTags.length > 0 &&
                    <Grid item xs={12}>
                        <OptionalTags optionalTags={optionalTags} control={control} errors={errors}/>
                    </Grid>
                }
            </>
        )
    }
    return <></>
}

export default GridTagFields;